var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.084,
    y1: 0.916,
    x2: 0.916,
    y2: 0.084,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d800b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.146,
    y1: 0.854,
    x2: 0.854,
    y2: 0.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.146,
    y1: 0.854,
    x2: 0.854,
    y2: 0.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f30072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e50097"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.928,7.052A8.81,8.81,0,0,0,23.37,4.14a5.881,5.881,0,0,0-1.384-2.126A5.883,5.883,0,0,0,19.86.63,8.808,8.808,0,0,0,16.947.072C15.668.014,15.259,0,12,0S8.332.014,7.052.072A8.811,8.811,0,0,0,4.139.63,5.881,5.881,0,0,0,2.014,2.014,5.882,5.882,0,0,0,.629,4.139,8.809,8.809,0,0,0,.072,7.052C.014,8.332,0,8.741,0,12s.014,3.668.073,4.948A8.808,8.808,0,0,0,.63,19.86a5.881,5.881,0,0,0,1.384,2.125A5.88,5.88,0,0,0,4.14,23.37a8.8,8.8,0,0,0,2.913.558C8.332,23.986,8.741,24,12,24s3.668-.014,4.948-.072a8.806,8.806,0,0,0,2.913-.558A6.135,6.135,0,0,0,23.37,19.86a8.807,8.807,0,0,0,.558-2.913C23.986,15.668,24,15.259,24,12s-.014-3.668-.072-4.948Zm-2.16,9.8a6.64,6.64,0,0,1-.413,2.228,3.974,3.974,0,0,1-2.277,2.277,6.639,6.639,0,0,1-2.228.413c-1.265.058-1.645.07-4.849.07s-3.584-.012-4.849-.07a6.642,6.642,0,0,1-2.228-.413,3.719,3.719,0,0,1-1.38-.9,3.717,3.717,0,0,1-.9-1.38,6.639,6.639,0,0,1-.413-2.228c-.058-1.265-.07-1.645-.07-4.849s.012-3.584.07-4.849a6.644,6.644,0,0,1,.413-2.228,3.72,3.72,0,0,1,.9-1.38,3.715,3.715,0,0,1,1.38-.9,6.638,6.638,0,0,1,2.228-.413C8.416,2.174,8.8,2.162,12,2.162h0c3.2,0,3.584.012,4.849.07a6.64,6.64,0,0,1,2.228.413,3.721,3.721,0,0,1,1.38.9,3.715,3.715,0,0,1,.9,1.38,6.633,6.633,0,0,1,.413,2.228c.058,1.265.07,1.645.07,4.849s-.012,3.584-.07,4.849Zm0,0",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.7,124.539a6.162,6.162,0,1,0,6.162,6.162A6.162,6.162,0,0,0,130.7,124.539Zm0,10.162a4,4,0,1,1,4-4A4,4,0,0,1,130.7,134.7Zm0,0",
    transform: "translate(-118.701 -118.701)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.81,90.065a1.44,1.44,0,1,1-1.44-1.44A1.44,1.44,0,0,1,364.81,90.065Zm0,0",
    transform: "translate(-344.964 -84.471)",
    fill: "url(#c)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e8c79068ab5421b711f6e6588f0ae8b6.svg";
export { ForwardRef as ReactComponent };